
export default [
  {
    path: '/admin/loan-currencies',
    name: 'loan-currency',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/loan-currency')
  }
]
